import styled from 'styled-components'

export const ClientViewWrapper = styled.div`
  position: relative;

  .page-title {
    position: relative;

    .link-edit {
      position: absolute;
      right: 0;

      svg {
        margin-bottom: 0;
        margin-top: 0px;
      }
    }
  }

  .section-wrapper {
    margin-bottom: 30px;

    &.first {
      font-family: ${props => props.theme.fonts.robotoRegular};
      font-size: ${props => props.theme.fontSizes.clients.clientView};
      color: ${props => props.theme.colors.secondary};
      padding: 40px 40px 65px 40px;
    }

    &.second {
      padding: 40px 40px 55px 40px;
    }

    .section-title {
      margin: 0 0 30px 0;
    }

    .section-label {
      margin: 0 0 7px 0;
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/Clients/ClientView/ClientViewWrapper/index.js